import { compactHeaderStyles as styles } from "@insite/content-library/Pages/CompactHeader";
import { getProp } from "@insite/mobius/utilities";
import { css } from "styled-components";

styles.page = {
    ...styles.page,
    css: css`
        ${styles.page?.css}
        z-index: ${getProp("theme.zIndex.menu")};
    `,
};
